var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { problemFromResponse } from './problem';
export class ClientError extends Error {
    constructor(message, options) {
        super(message, options);
        this.name = 'ClientError';
        this.problem = options === null || options === void 0 ? void 0 : options.problem;
        // See https://github.com/microsoft/TypeScript/issues/13965
        Object.setPrototypeOf(this, ClientError.prototype);
    }
}
export class ServerError extends Error {
    constructor(message, options) {
        super(message, options);
        this.name = 'ServerError';
        this.problem = options === null || options === void 0 ? void 0 : options.problem;
        // See https://github.com/microsoft/TypeScript/issues/13965
        Object.setPrototypeOf(this, ServerError.prototype);
    }
}
export function errorMiddleware() {
    return (input, init, next) => __awaiter(this, void 0, void 0, function* () {
        const response = yield next(input, init);
        if (!response.ok) {
            if (response.status >= 400 && response.status < 500) {
                const message = `API returned ${response.status} status`;
                const problem = yield problemFromResponse(response);
                const error = new ClientError(message, { problem });
                throw error;
            }
            if (response.status >= 500 && response.status < 600) {
                const message = `API returned ${response.status} status`;
                const problem = yield problemFromResponse(response);
                const error = new ServerError(message, { problem });
                throw error;
            }
        }
        return response;
    });
}
